export default "__VITE_ASSET__BEONSvo4__"